import { render, staticRenderFns } from "./DownloadDocumentsModal.vue?vue&type=template&id=f2e71ad4&scoped=true&"
import script from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocumentsModal.vue?vue&type=style&index=0&id=f2e71ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e71ad4",
  null
  
)

export default component.exports